@if (controlDirective) {
  <div class="search-and-pick-container">
    <div class="search-and-pick-container__child">
      <plugins-user-search
        [searchType]="searchType()"
        [placeholderText]="searchFieldPlaceholderText()"
        [formControl]="searchControl"
        [maxAllowed]="maxAllowed()"
        [pickedLength]="pickedLength$ | async"
        [size]="size()"
        [detailedTitle]="detailedTitle()"
        [inputId]="inputId"
        [includedGroups]="includedGroups()"
        [color]="color()"
      />
    </div>
    <div class="search-and-pick-container__child">
      <plugins-picked-users
        [size]="size()"
        [searchType]="searchType()"
        [placeholderItem]="pickedEntitiesPlaceholder()"
        [detailedTitle]="detailedTitle()"
        [disabled]="disablePicked()"
        [profileLinksEnabled]="profileLinksEnabled()"
      />
    </div>
  </div>
}
